const StatusConfirmation = ({ t,currentStatus, status, handleConfirm }) => {
  return (
    <>
      <div
        className="modal fade"
        id="status-confirmation-modal"
        tabIndex="-1"
        aria-labelledby="status-confirmation-modal-title"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content my-modal">
            <div className="modal-body">
              <i className="fas fa-exclamation-triangle text-warning"></i>{" "}
              {t("statusChangeConfirmation")}{" "}
              <strong>
                {t(currentStatus)} → {t(status)}
              </strong>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn-modal"
                data-bs-dismiss="modal"
                onClick={handleConfirm}
              >
                {t("ok")}
              </button>

              <button
                type="button"
                className="btn-modal"
                data-bs-dismiss="modal"
              >
                {t("cancel")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatusConfirmation;

